import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import {
    ExtraPlacesRunnerCell,
    PlaceCell,
    PlacesRaceSummaryRowHeader,
    SilkRaceSummary,
    SilkRaceSummaryHrWrapper,
} from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/extraPlacesSummary/RaceSummaryRowExtraPlaces.style';

interface PropsType {
    place?: React.ReactNode;
    runner?: React.ReactNode;
    selectionId: SelectionId;
    isNonRunner?: boolean;
}

export const RaceSummaryRowExtraPlaces = observer('RaceSummaryRowExtraPlaces', (props: PropsType) => {
    const { place, runner, selectionId, isNonRunner } = props;

    const selectionModel = selectionId.getModel();
    if (selectionModel === null) {
        return null;
    }

    const marketModel = selectionModel.getMarket();
    if (marketModel === null) {
        return null;
    }

    const eventModel = marketModel.getEvent();
    if (eventModel === null) {
        return null;
    }

    const silkUrl = selectionModel.metaDataSilkUrl ?? '';
    const silkAltDesc = selectionModel.metaDataSilk ?? 'Silk image';

    return (
        <PlacesRaceSummaryRowHeader isNonRunner={isNonRunner}>
            <PlaceCell>{place}</PlaceCell>
            <SilkRaceSummaryHrWrapper>
                <SilkRaceSummary
                    alt={silkAltDesc}
                    imgBase={{
                        src: silkUrl,
                        optimizeOptions: {
                            quality: 85,
                            width: 45,
                        },
                    }}
                />
            </SilkRaceSummaryHrWrapper>

            <ExtraPlacesRunnerCell>{runner}</ExtraPlacesRunnerCell>
        </PlacesRaceSummaryRowHeader>
    );
});
